import React, { forwardRef } from "react";
import "./productPopUP.css";

const ProductPopUP = forwardRef(({ isExpanded, onProductClick }, ref) => {
  const products = [
    {
      imgSrc: "/images/Frame (1).svg",
      name: "BounceProof",
      description: "Validate emails before you send.",
      comingSoon: false,
      bgColor: "#FFF7EE",
      link: "/bounce-proof",
    },
    {
      imgSrc: "/images/Frame (2).svg",
      name: "IDProof",
      description: "Verify identity. Build trust.",
      comingSoon: false,
      bgColor: "#FFF5F6",
      link: "/id-proof",
    },
    {
      imgSrc: "/images/Frame (3).svg",
      name: "TamperProof",
      description: "If a document has been changed, you'll know.",
      comingSoon: false,
      bgColor: "#FFF3FE",
      link: "/tamper-proof",
    },
    {
      imgSrc: "/images/Frame (4).svg",
      name: "OCRProof",
      description: "Turn documents into data.",
      comingSoon: true,
      bgColor: "#F1FFFC",
    },
    {
      imgSrc: "/images/Frame (5).svg",
      name: "Finnalyzer",
      description: "Analyse financial statements.",
      comingSoon: false,
      bgColor: "#F4FFE7",
      link: "/finnalyzer",
    },
    {
      imgSrc: "/images/Frame (6).svg",
      name: "Trustify",
      description: "Confidence with trusted identity score.",
      comingSoon: true,
      bgColor: "#EEFCFF",
    },
  ];

  const handleProductClick = (link, event) => {
    event.stopPropagation();
    onProductClick(link);
  };

  return (
    <>
      <div
        ref={ref}
        className={`popup-container ${isExpanded ? "expanded" : ""}`}
      >
        <div className="product-grid">
          {products.map((product, index) => (
            <div
              key={index}
              className="product-cards"
              style={{ backgroundColor: product.bgColor }}
              onClick={(event) => {
                handleProductClick(product, event);
              }}
            >
              <div className="product-info">
                <div className="product-name">
                  <img src={product.imgSrc} alt="" />
                  {product.name}
                </div>
                <div className="product-description">{product.description}</div>
              </div>
              <div>
                {product.comingSoon && (
                  <div className="coming-soon">Coming Soon</div>
                )}
                {!product.comingSoon && (
                  <div className="arrow">
                    <img src="/images/Icons (1).svg" alt="" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
});

ProductPopUP.displayName = "ProductPopUP";

export default ProductPopUP;
